import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { inviteUserMutation } from "../mutations";
import { accessManagementQuery } from "../queries";

/**
 * Hook to invite a user to the current tenant with a specified role.
 * If the user doesn't exist, they will be created.
 * Automatically invalidates the access management query on success.
 *
 * @example
 * ```tsx
 * const { mutate, isPending } = useInviteUser();
 *
 * const handleInvite = () => {
 *   mutate({ email: "user@example.com", role: "site_manager:S0-site1" });
 * };
 * ```
 */
export function useInviteUser() {
  const apiConfig = useApiConfig();
  const queryClient = useQueryClient();

  const mutationApiConfig = {
    tenantId: apiConfig.tenant?.tenantId,
    apiBaseUrl: apiConfig.tenant?.apiBaseUrl,
    authenticatedFetch: apiConfig.authenticatedFetch,
  };

  return useMutation({
    ...inviteUserMutation(mutationApiConfig, {}),
    onSuccess: () => {
      const queryKey = accessManagementQuery(apiConfig, {}).queryKey;
      void queryClient.invalidateQueries({ queryKey });
    },
  });
}
